<template>
  <div>
    <ul
      class="step-wrap"
      v-if="orderDetail.statusList && orderDetail.statusList.length"
    >
      <li
        :class="isCurrentStatus(item.currentStatus) === 'true' ? 'active' : ''"
        v-for="(item, index) in orderDetail.statusList"
        :key="index"
      >
        <span>{{ item.orderStatusName }}</span>
        <b>{{ item.statusTime }}</b>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "orderStep",
  components: {},
  props: {
    orderDetail: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    isCurrentStatus() {
      return function(status) {
        //当前状态，1：未到达，2：已经过，3：刚好到达
        switch (status) {
          case 2:
          case 3:
            return "true";
          default:
            return "false";
        }
      };
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@style/base";
@import "@style/common";
.step-wrap {
  border-radius: 8px;
  border: 1px solid #eee;
  padding: 0 15px 0 20px;
  li {
    display: flex;
    justify-content: space-between;
    color: #636569;
    height: 60px;
    padding-left: 6px;
    &.active {
      span {
        color: #000;
        font-weight: 500;
        &::before {
          background-color: #44bd2b;
        }
        &::after {
          background-color: #44bd2b;
        }
      }
    }
    span {
      font-size: 14px;
      line-height: 60px;
      padding-left: 34px;
      position: relative;
      &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        width: 2px;
        height: 52px;
        background-color: #ccc;
        position: absolute;
        left: 3px;
        top: -45px;
        transform: translateY(20px);
      }
    }
    b {
      font-size: 12px;
      line-height: 60px;
    }
    &:first-child {
      span {
        &::after {
          height: 0px;
        }
      }
    }
    &:last-child {
      &.active {
        span {
          &::before {
            width: 14px;
            height: 14px;
            background-image: url("https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20230716154549557-icon_arrive.png");
            background-size: cover;
            left: -2px;
          }
        }
      }
    }
  }
}
</style>
